import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import WelcomeInfoTitleAndSubtitle
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/WelcomeRework/WelcomeTitleAndSubtitle';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import React from 'react';
import { FDStack } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';

function OnboardingMoneyPsychQuestionLayout() {
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  return (
    <FDStack direction={'column'} spacing={4} {...dataAttrs('onboarding-welcome-money-psych-question', resource)}>
      <WelcomeInfoTitleAndSubtitle title={resource.attr('title')} subtitle={resource.attr('subtitle')} />
      <MetaControlField attr={'answer'} />
      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
        NextButtonProps={{
          buttonLabel: 'Continue',
        }}
      />
    </FDStack>
  );
}

OnboardingMoneyPsychQuestionLayout.propTypes = {
};

OnboardingMoneyPsychQuestionLayout.defaultProps = {
};

export default OnboardingMoneyPsychQuestionLayout;
